import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";

import Gallery from 'components/common/Gallery';
import SpecialOffers from 'components/common/SpecialOffers';

import * as benefitApis from 'apis/benefits';


export const OfferDetails = () => {
      const assetUrl = process.env.REACT_APP_TAURIAN_ASSET_URL;
    const { id } = useParams();
    const [benefit, setBenefit] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await benefitApis.fetchBenefitWithPartner(id);
        setBenefit(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

    return (
        <div className="container mt-400">
            <div className="row">

                <div className="col-12 col-md-7 pr-md-300 mb-300">
                    <Gallery images= {benefit?.partner?.images}/>

                    <div className="mt-300 d-xs-block d-md-none">
                        <h2 className="title ff-inter-bold fs-300 lh-300">{benefit?.partner?.name}</h2>
                        <div className="category">{benefit?.partner?.category}</div>
                    </div>

                    <div className={`mt-300 description fs-200 ff-inter-light`}>
                        {benefit?.partner?.description}
                    </div>
                </div>

                <div className="col-md-5">
                    <div className="mb-300 d-xs-none d-md-block">
                        <h2 className="title ff-inter-bold fs-300 lh-300">{benefit?.partner?.name}</h2>
                        <div className="category">{benefit?.partner?.category}</div>
                    </div>

                    <div className={`offer-info mb-300 br-150 bg-light-blush p-200 ff-inter-medium border bw-25 br-100 bc-bright-red `}>
                        <h3 className="fs-200 ff-inter-semibold text-bright-red mb-50">Member Exclusive Offer</h3>
                       10% at
                    </div>

                    <div className={`contact-info fs-200 ff-inter-light bc-dark-gray`}>
                        <h4 className="mb-100 fs-200 ff-inter-medium">Claim this offer at:</h4>

                        {
                            benefit?.partner?.addresses.map((address) => {
                                return(
                                    <div className="b-bottom pb-100 mb-100 bc-dark-gray">
                            <div className="website mb-25">
                                <strong className="ff-inter">website:&nbsp;</strong>
                                <a className="link text-bright-red" href={`${benefit.partner.website}`} target="_blank">{benefit?.partner?.website}</a>
                            </div>

                            <div className="address mb-25"><strong className="ff-inter">shop address:&nbsp;</strong>{address}</div>

                            <div className="email mb-25">
                                <strong className="ff-inter">email:&nbsp;</strong>
                                <a className="link text-bright-red" href="mailto:info@bandidospitstop.com" target="_blank">{benefit?.partner?.email}</a>
                            </div>

                            <div className="contact mb-25">
                                <strong className="ff-inter">contact:&nbsp;</strong>
                                <a className="link text-bright-red" href={`tel:${benefit?.partner?.phone}`}>{benefit?.partner?.phone}</a>
                            </div>
                        </div>

                                )
                            })
                        }

                        
                        

                        {/* <div className=" pb-100 mb-100">
                            <div className="website mb-25">
                                <strong className="ff-inter">website:&nbsp;</strong>
                                <a className="link text-bright-red" href="http://www.bandidospitstop.com" target="_blank">bandidospitstop.com</a>
                            </div>

                            <div className="address mb-25"><strong className="ff-inter">shop address:&nbsp;</strong> Quis autem vel eum iure reprehenderit,
                                qui in ea voluptate velit,
                                esse quam</div>

                            <div className="email mb-25">
                                <strong className="ff-inter">email:&nbsp;</strong>
                                <a className="link text-bright-red" href="mailto:info@bandidospitstop.com" target="_blank">info@bandidospitstop.com</a>
                            </div>

                            <div className="contact mb-25">
                                <strong className="ff-inter">contact:&nbsp;</strong>
                                <a className="link text-bright-red" href="tel:+91-8589020202">+91-8589020202</a>
                            </div>
                        </div> */}

                    </div>
                </div>
            </div>

            <div className="mt-1400 mb-300">
                {benefit?.partner?.ads.map((ad)=>{
                    return(
                        <>
                        <SpecialOffers image={ad} />
                <div className="b-bottom my-300 bc-dark-gray"></div>
                </>
                    )
                })}
                
            </div>
        </div>

    );
};

export default OfferDetails;